/**
 * The names of the messages sent between the Gateway iFrame and GatewayJS
 * library.
 */
export var GatewayMessageType;
(function (GatewayMessageType) {
    GatewayMessageType["ToggleSettings"] = "toggleSettings";
    GatewayMessageType["Pause"] = "pause";
    GatewayMessageType["Resume"] = "resume";
    GatewayMessageType["Ready"] = "ready";
    GatewayMessageType["TransferDetails"] = "transferDetails";
    GatewayMessageType["Transfers"] = "Transfers";
    GatewayMessageType["GetTransfers"] = "GetTransfers";
    GatewayMessageType["Status"] = "status";
    GatewayMessageType["GetStatus"] = "getStatus";
    GatewayMessageType["TransferUpdated"] = "transferUpdated";
    GatewayMessageType["Cancel"] = "cancel";
    GatewayMessageType["Error"] = "error";
    GatewayMessageType["Done"] = "done";
    GatewayMessageType["SendEthereumTx"] = "sendEthereumTx";
    GatewayMessageType["GetEthereumTxStatus"] = "getEthereumTxStatus";
    GatewayMessageType["SendEthereumTxConfirmations"] = "sendEthereumTxConfirmations";
    GatewayMessageType["GetEthereumTxBurn"] = "getEthereumTxBurn";
    GatewayMessageType["FindMintTransaction"] = "findMintTransaction";
    GatewayMessageType["RequestNotificationPermission"] = "requestNotificationPermission";
    GatewayMessageType["ShowNotification"] = "showNotification";
    GatewayMessageType["Acknowledgement"] = "acknowledgement";
})(GatewayMessageType || (GatewayMessageType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVzc2FnZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbWVzc2FnZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT0E7OztHQUdHO0FBQ0gsTUFBTSxDQUFOLElBQVksa0JBNEJYO0FBNUJELFdBQVksa0JBQWtCO0lBQzFCLHVEQUFpQyxDQUFBO0lBQ2pDLHFDQUFlLENBQUE7SUFDZix1Q0FBaUIsQ0FBQTtJQUNqQixxQ0FBZSxDQUFBO0lBQ2YseURBQW1DLENBQUE7SUFFbkMsNkNBQXVCLENBQUE7SUFDdkIsbURBQTZCLENBQUE7SUFFN0IsdUNBQWlCLENBQUE7SUFDakIsNkNBQXVCLENBQUE7SUFDdkIseURBQW1DLENBQUE7SUFFbkMsdUNBQWlCLENBQUE7SUFDakIscUNBQWUsQ0FBQTtJQUNmLG1DQUFhLENBQUE7SUFFYix1REFBaUMsQ0FBQTtJQUNqQyxpRUFBMkMsQ0FBQTtJQUMzQyxpRkFBMkQsQ0FBQTtJQUMzRCw2REFBdUMsQ0FBQTtJQUN2QyxpRUFBMkMsQ0FBQTtJQUUzQyxxRkFBK0QsQ0FBQTtJQUMvRCwyREFBcUMsQ0FBQTtJQUVyQyx5REFBbUMsQ0FBQTtBQUN2QyxDQUFDLEVBNUJXLGtCQUFrQixLQUFsQixrQkFBa0IsUUE0QjdCIn0=